// extracted by mini-css-extract-plugin
export default {"mnImageDetailOperationView":"index_mnImageDetailOperationView__+JDOC","img-actions":"index_img-actions__DFguW","action-pagination":"index_action-pagination__XMVOK"};